import { render, staticRenderFns } from "./RecoveryCode.vue?vue&type=template&id=68fd0f7a&scoped=true&"
import script from "./RecoveryCode.vue?vue&type=script&lang=js&"
export * from "./RecoveryCode.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryCode.vue?vue&type=style&index=0&id=68fd0f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd0f7a",
  null
  
)

export default component.exports